import { createBooleanDevicePreference } from './devicePreference';

// Per-device toggle for the effort-meter reminder pulse (AP-0d): a rare,
// gentle cue on the meter while a pending set sits unlogged. Default ON;
// the Settings style card offers the off switch. Reduced-motion renders a
// static cue instead (see useEffortNudge).
const pref = createBooleanDevicePreference(
  'jackedlogs.effortNudge.v1.enabled',
  true,
);

export const useEffortNudgeEnabled = pref.usePreference;
